<div
    class="flex flex-col flex-auto items-center sm:justify-center min-w-0 sm:p-8 md:py-16 md:px-16"
>
    <div class="flex w-full h-full rounded-2xl shadow-2xl overflow-hidden">
        <div class="w-full py-8 px-4 sm:p-12 md:p-16 text-black">
            <div
                class="flex flex-col w-full h-full justify-center mx-auto sm:mx-0"
            >
                <!-- Logo -->
                <div class="h-18">
                    <img
                        [src]="branding.currentFullLogoUrl()"
                        [alt]="branding.logoAlt"
                        class="h-18 bg-cover"
                    />
                </div>

                <!-- Title -->
                <div
                    class="mt-8 text-4xl font-extrabold tracking-tight leading-tight text-center"
                    >You have been signed out!</div
                >
                <div class="flex justify-center mt-0.5 font-medium">
                    <!-- Redirect countdown -->
                    <ng-container *ngIf="countdown > 0">
                        Redirecting in
                        {{ countdown | i18nPlural : countdownMapping }}
                    </ng-container>

                    <!-- Redirect message -->
                    <ng-container *ngIf="countdown === 0">
                        You are now being redirected!
                    </ng-container>
                </div>

                <!-- Form footer -->
                <div
                    class="mt-8 text-md font-medium text-secondary text-center"
                >
                    <span>Go to</span>
                    <a
                        class="ml-1 text-primary-500 hover:underline"
                        [routerLink]="[authConfig.getConfig().routes.signIn]"
                        >sign in
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
